// User management routes
import UsersManagement from '../../views/Users.vue'
import CreateUser from '../../views/CreateUser.vue'
import RolesManagement from '../../views/RolesManagement.vue'
import RolesAndPermissions from '../../components/RolesAndPermissions.vue'

export default [
  {
    path: '/users',
    name: 'Users',
    component: UsersManagement,
    meta: { 
      requiresAuth: true,
      title: 'User Management'
    }
  },
  {
    path: '/users/create',
    name: 'CreateUser',
    component: CreateUser,
    meta: { 
      requiresAuth: true,
      title: 'Create User'
    }
  },
  {
    path: '/roles',
    name: 'Roles',
    component: RolesManagement,
    meta: { 
      requiresAuth: true,
      title: 'Role Management'
    }
  },
  {
    path: '/roles-permissions',
    name: 'RolesAndPermissions',
    component: RolesAndPermissions,
    meta: { 
      requiresAuth: true,
      title: 'Roles and Permissions'
    }
  }
] 